import { graphql } from 'generated/gql/account-manager';
import { useAmQuery } from 'graphql/useAmQuery';
import { useParams } from 'react-router';
import { useCurrentUser } from './useCurrentUser';
import { useJwt, userDataFromToken } from './useJwt';

const teamMemberAbilitiesQueryDocument = graphql(`
  query teamMemberAbilities(
    $wordpressUserId: Int
    $accountId: Int
    $platformSiteId: Int
  ) {
    teamMemberAbility(
      wordpressUserId: $wordpressUserId
      accountId: $accountId
      platformSiteId: $platformSiteId
    ) {
      action
      subject
      limitingIds
    }
  }
`);

export function useTeamMemberAbilities() {
  const { accountId, siteId } = useParams();
  const { data } = useJwt();
  const wordpressUserId = userDataFromToken(data?.token)?.id;

  /**
   * Default to using the accountId from the URL if it exists; fallback to
   * using the active account and siteId if no accountId in the URL.
   *
   * TODO: ALUM - always use accountId from the URL; don't use active account
   * or site ID.
   */
  const userQuery = useCurrentUser();
  const activeAccountId = userQuery.data?.user?.activeAccount?.id;
  const variables = accountId
    ? {
        wordpressUserId: Number(wordpressUserId),
        accountId: Number(accountId),
      }
    : {
        wordpressUserId: Number(wordpressUserId),
        accountId: activeAccountId,
        platformSiteId: Number(siteId),
      };

  const hasRequiredQueryVariables = Boolean(
    variables.wordpressUserId &&
    (variables.accountId || variables.platformSiteId)
  );

  const query = useAmQuery(teamMemberAbilitiesQueryDocument, variables, {
    enabled: hasRequiredQueryVariables,
  });

  return query;
}
